import clsx from 'clsx';
import Style from './builderFieldLabel.module.scss';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { ReactComponent as TooltipIcon } from 'assets/img/generalBuilder/tip_16.svg';
import { Tooltip } from 'uikit/tooltip/tooltip.component';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';

export type BuilderFieldLabelProps = {
  text?: string;
  prefix?: string;
  tooltip?: ReactNode;
  isBold?: boolean;
  disabled?: boolean;
  className?: string;
  rightSection?: React.JSX.Element | string;
  isOptional?: boolean;
  description?: string;
};

export const BuilderFieldLabel: FC<PropsWithChildren<BuilderFieldLabelProps>> = ({
  prefix,
  text,
  tooltip,
  className,
  isBold,
  disabled,
  rightSection,
  children,
  isOptional,
  description,
}) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.UiKit.Wrappers');
  if (!text) {
    return <>{children}</>;
  }

  return (
    <div className={clsx(Style.labelContainer, className)}>
      <div data-disabled={disabled} className={Style.labelWithDescription}>
        <div className={Style.label}>
          {prefix && <div className={Style.prefix}>{prefix}</div>}
          <div>
            <div className={Style.labelWithTooltip}>
              <span className={Style.text} data-is-bold={isBold}>
                {text}
              </span>
              {isOptional && <span className={Style.optionalMark}>{t('Optional')}</span>}
              {tooltip && (
                <Tooltip tooltipContent={tooltip}>
                  <TooltipIcon className={Style.icon} />
                </Tooltip>
              )}
            </div>

            {description && <div className={Style.description}>{description}</div>}
          </div>

          <div className={Style.rightComponent}>{rightSection}</div>
        </div>
      </div>
      {children}
    </div>
  );
};
